// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Dx2O","image-wrapper":"_2fTxk","content-wrapper":"_1kUdj","headline":"_44E2N","content":"_2V6Fm","button":"iNwFX","image":"_17uwW"};